import i18n from 'i18next'
import { FormInputConfig, FormInputItem } from '../../../../utils/formUtils/types'

export const inputsConfig = (): FormInputConfig => ({
    mainForm: [
        { label: i18n.t('form.diary.fullName'), name: 'fullName', required: true },
        { label: i18n.t('table.header.diary.propertyType'), name: 'propertyType', required: true },
        { label: i18n.t('app.common.area', { areaUnit: '' }), name: 'area', required: true },
        { label: i18n.t('table.header.diary.price', { price: '' }), name: 'price', required: true },
    ] as FormInputItem[],
})
